export const dict = {
    Placeholder: "Search",
    LiveEvent: "Live Now",
    NoSearchResults: "No Search Results found",
    SearchResults: "Search Results",
    RecommendedResults: "Recommended Results",
    RecentResults: "Recent Results",
    Cancel: "Cancel",
    ClearAll: "Clear all",
    ClockMins: "{0}'",
    StartsIn: "Starts in",
    FirstHalf: "H1",
    SecondHalf: "H2",
    BreakAfterFirstHalf: "HT",
    Overtime: "OT",
    FirstOvertime: "OT1",
    BreakAfterFirstOvertime: "OT1",
    SecondOvertime: "OT2",
    Overtime_Soccer: "ET",
    FirstOvertime_Soccer: "ET 1H",
    BreakAfterFirstOvertime_Soccer: "ET HT",
    SecondOvertime_Soccer: "ET 2H",
    FirstQuarter: "Q1",
    SecondQuarter: "Q2",
    ThirdQuarter: "Q3",
    FourthQuarter: "Q4",
    BreakAfterFirstQuarter: "Q1",
    BreakAfterSecondQuarter: "HT",
    BreakAfterThirdQuarter: "Q3",
    BreakAfterFourthQuarter: "Q4",
    FirstPeriod: "P1",
    SecondPeriod: "P2",
    ThirdPeriod: "P3",
    BreakAfterFirstPeriod: "P1",
    BreakAfterSecondPeriod: "P2",
    BreakAfterThirdPeriod: "P3",
    FirstSet: "1st set",
    SecondSet: "2nd set",
    ThirdSet: "3rd set",
    FourthSet: "4th set",
    FifthSet: "5th set",
    FirstInning: "1st Inn",
    SecondInning: "2nd Inn",
    ThirdInning: "3rd Inn",
    FourthInning: "4th Inn",
    FifthInning: "5th Inn",
    SixthInning: "6th Inn",
    SeventhInning: "7th Inn",
    EighthInning: "8th Inn",
    NinthInning: "9th Inn",
};
//# sourceMappingURL=dict.js.map